/**
 * Configuración › API y desarrolladores › "Contacto técnico de la API" (spec 2026-10-29 §8).
 *
 * Hasta 3 correos (api_contacto_tecnico) que además del dueño reciben el aviso de tráfico rechazado de la API. La
 * sección (`noble/configuracion/desarrolladores`, `[data-fd-contacto-tecnico]`) pregunta a
 * v2/desarrolladores/contacto_ajax qué hay y si la persona puede editar (solo el dueño); sin la tabla dice "estará
 * disponible muy pronto". Guardar va a contacto_guardar_ajax.
 *
 * Reglas: todo AJAX por window.FD.ajax (inyecta X-FD-Csrf), nada de onclick en línea, y el servidor vuelve a validar
 * TODO (validarCorreos es el espejo de Api_exceso::correos_tecnicos_validos). Las funciones exportadas son puras
 * (Vitest, entorno node); el montaje solo corre en el navegador.
 */

export var MAX_CORREOS = 3;
export var MAX_LARGO = 120;
export var MSG_TOPE = 'Puedes registrar hasta 3 correos de contacto técnico.';

// Más estricto que el servidor a propósito no: algo@dominio.tld; el servidor decide con FILTER_VALIDATE_EMAIL.
var FORMATO = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Mensaje para un correo que no sirve (recortado: lo que escribió la persona puede ser largo). */
function msgCorreo(c) {
  var ver = String(c).replace(/[\u0000-\u001f\u007f]+/g, ' ');
  if (ver.length > 40) { ver = ver.slice(0, 40) + '…'; }
  return 'Revisa este correo, no parece completo: ' + ver;
}

/**
 * Valida lo que escribió la persona. Quita vacíos y espacios, junta repetidos sin distinguir mayúsculas (queda el
 * primero) y permite hasta 3. Con error no devuelve correos.
 * @returns {{ok:boolean, correos:string[], error:(string|null)}}
 */
export function validarCorreos(lista) {
  var correos = [];
  var vistos = {};
  var crudos = Array.isArray(lista) ? lista : [];
  for (var i = 0; i < crudos.length; i++) {
    var c = String(crudos[i] == null ? '' : crudos[i]).trim();
    if (c === '') { continue; }
    if (c.length > MAX_LARGO || !FORMATO.test(c)) {
      return { ok: false, correos: [], error: msgCorreo(c) };
    }
    var k = c.toLowerCase();
    if (vistos[k]) { continue; }
    vistos[k] = true;
    correos.push(c);
  }
  if (correos.length > MAX_CORREOS) { return { ok: false, correos: [], error: MSG_TOPE }; }
  return { ok: true, correos: correos, error: null };
}

/** El mensaje que dejó el servidor en una respuesta de error de FD.ajax ('' si no hay). */
export function mensajeDeError(jqXHR) {
  var j = jqXHR && jqXHR.responseJSON;
  return (j && (j.message || j.msg)) ? String(j.message || j.msg) : '';
}

function montar(sec) {
  if (sec.dataset.fdContactoMontado) { return; }
  sec.dataset.fdContactoMontado = '1';
  var cargando = sec.querySelector('#contacto-cargando');
  var noDisp = sec.querySelector('#contacto-no-disponible');
  var form = sec.querySelector('#contacto-form');
  var inputs = Array.prototype.slice.call(sec.querySelectorAll('.fd-contacto-correo'));
  var soloLectura = sec.querySelector('#contacto-solo-lectura');
  var error = sec.querySelector('#contacto-error');
  var ok = sec.querySelector('#contacto-ok');
  var boton = sec.querySelector('#contacto-guardar');
  var genérico = (window.FD && window.FD.texto && window.FD.texto.reintentar) || 'Inténtalo de nuevo en un momento.';

  function avisoError(texto) {
    error.textContent = texto || '';
    error.classList.toggle('text-danger', !!texto);
    error.hidden = !texto;
  }
  function avisoOk(texto) { ok.textContent = texto || ''; ok.hidden = !texto; }
  function pintar(correos, puedeEditar) {
    inputs.forEach(function (inp, i) {
      inp.value = correos[i] || '';
      inp.disabled = !puedeEditar;
    });
    boton.hidden = !puedeEditar;
    boton.disabled = !puedeEditar;
    soloLectura.hidden = !!puedeEditar;
  }

  window.FD.ajax({ method: 'GET', url: sec.getAttribute('data-url-leer') })
    .done(function (r) {
      cargando.hidden = true;
      if (!r || r.success !== true || r.disponible !== true) {
        noDisp.hidden = false;
        return;
      }
      form.hidden = false;
      pintar(r.correos || [], r.puede_editar === true);
    })
    .fail(function (jqXHR) {
      cargando.hidden = true;
      noDisp.hidden = false;
      var m = mensajeDeError(jqXHR);
      if (m && jqXHR.status !== 403) { noDisp.textContent = m; }
    });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (boton.disabled) { return; }
    avisoError(''); avisoOk('');
    var v = validarCorreos(inputs.map(function (i) { return i.value; }));
    if (!v.ok) { avisoError(v.error); return; }
    boton.disabled = true;
    window.FD.ajax({ method: 'POST', url: sec.getAttribute('data-url-guardar'), data: { correos: v.correos } })
      .done(function (r) {
        if (r && r.success === true) {
          pintar(r.correos || [], true);
          avisoOk('Guardado. Estos correos también recibirán los avisos de la API.');
        } else {
          avisoError(genérico);
        }
      })
      .fail(function (jqXHR) {
        // 403 y 419 ya los avisa FD.ajax; el 422 (formato) y el 5xx traen su mensaje.
        if (jqXHR.status !== 403 && jqXHR.status !== 419) { avisoError(mensajeDeError(jqXHR) || genérico); }
      })
      .always(function () { boton.disabled = false; });
  });
}

// Montaje: SOLO en el navegador (bajo Vitest no hay `window`).
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.FD || !window.FD.ajax) { return; }
    document.querySelectorAll('[data-fd-contacto-tecnico]').forEach(montar);
  });
}
